/* DOUBLIX — product-form.js
   Galerie, sélection de variante, upload photo, quantité, pack multi-figurines.

   Ajout au panier en AJAX (/cart/add.js) puis ouverture du tiroir coulissant, pour que
   le client voie tout de suite son panier ET les add-ons proposés. La photo est envoyée
   en multipart dans la requête AJAX — /cart/add.js l'accepte bien sur ce store (comme le
   thème d'origine). Si le réseau/AJAX échoue, on retombe sur le POST natif (recharge /cart)
   pour garantir que la photo parte quand même. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-main]');
  if (!root) return;

  var MAX_BYTES = 15 * 1024 * 1024;
  var ACCEPTED = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  var routes = (window.theme && window.theme.routes) || {};

  /* ---------- Galerie ---------- */

  var slides = root.querySelectorAll('[data-slide]');
  var thumbs = root.querySelectorAll('[data-thumb]');

  function activateSlideIndex(idx) {
    slides.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-slide') === idx);
    });
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === idx);
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateSlideIndex(thumb.getAttribute('data-thumb'));
    });
  });

  // Galerie qui suit la variante : quand une variante a un média dédié (ex. Chibi), on
  // bascule la galerie dessus. La table variante→média est rendue côté serveur.
  var variantMedia = {};
  var vmEl = root.querySelector('[data-variant-media]');
  if (vmEl) { try { variantMedia = JSON.parse(vmEl.textContent) || {}; } catch (e) { variantMedia = {}; } }

  function showVariantMedia(variantId) {
    var mediaId = variantMedia[variantId];
    if (!mediaId) return;
    var slide = root.querySelector('[data-slide][data-media-id="' + mediaId + '"]');
    if (slide) activateSlideIndex(slide.getAttribute('data-slide'));
  }

  /* ---------- Variantes ---------- */

  var variants = [];
  var jsonEl = root.querySelector('[data-product-json]');
  if (jsonEl) {
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
  }

  var variantInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare-price]');
  var atc = root.querySelector('[data-atc]');
  var atcLabel = root.querySelector('[data-atc-label]');
  var optionInputs = root.querySelectorAll('[data-option-input]');

  function money(cents) {
    if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(cents);
    return (cents / 100).toFixed(2);
  }

  function selectedOptions() {
    var opts = [];
    root.querySelectorAll('[data-option-input]:checked').forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-option-position'), 10) - 1;
      opts[pos] = el.value;
    });
    return opts;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant() {
    if (!variants.length) return;
    var opts = selectedOptions();
    if (!opts.length) return;

    var v = findVariant(opts);
    var strings = (window.theme && window.theme.strings) || {};

    if (!v) {
      if (atc) atc.disabled = true;
      if (atcLabel) atcLabel.textContent = strings.soldOut || 'Indisponible';
      return;
    }

    if (variantInput) variantInput.value = v.id;
    showVariantMedia(v.id);
    if (priceEl) priceEl.textContent = money(v.price);

    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = money(v.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (atc) atc.disabled = !v.available;
    if (atcLabel) {
      atcLabel.textContent = v.available
        ? (strings.addToCart || 'Ajouter au panier')
        : (strings.soldOut || 'Épuisé');
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }

  optionInputs.forEach(function (el) { el.addEventListener('change', updateVariant); });
  updateVariant();

  /* ---------- Quantité ---------- */

  var qtyInput = root.querySelector('[data-qty-input]');
  root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var step = parseInt(btn.getAttribute('data-qty-step'), 10);
      var next = (parseInt(qtyInput.value, 10) || 1) + step;
      qtyInput.value = Math.max(1, next);
    });
  });

  /* ---------- Photo ---------- */

  var drop = root.querySelector('[data-photo-drop]');
  var fileInput = root.querySelector('[data-photo-input]');
  var picked = root.querySelector('[data-photo-picked]');
  var pickedName = root.querySelector('[data-photo-name]');
  var changeBtn = root.querySelector('[data-photo-change]');
  var errorEl = root.querySelector('[data-photo-error]');
  var form = document.getElementById('product-form');

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError() {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function clearFile() {
    if (fileInput) fileInput.value = '';
    if (drop) drop.classList.remove('is-picked');
    if (picked) picked.hidden = true;
  }

  function acceptFile(file) {
    clearError();

    if (file.size > MAX_BYTES) {
      showError(root.getAttribute('data-err-size') || 'Photo trop lourde — 15 Mo maximum.');
      clearFile();
      return false;
    }
    if (file.type && ACCEPTED.indexOf(file.type) === -1) {
      showError(root.getAttribute('data-err-format') || 'Format non supporté.');
      clearFile();
      return false;
    }

    if (pickedName) pickedName.textContent = file.name;
    if (picked) picked.hidden = false;
    if (drop) drop.classList.add('is-picked');
    return true;
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) acceptFile(f);
      else clearFile();
    });
  }

  if (changeBtn && fileInput) {
    changeBtn.addEventListener('click', function () { fileInput.click(); });
  }

  if (drop && fileInput) {
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) {
        e.preventDefault();
        drop.classList.add('is-dragging');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) {
        e.preventDefault();
        drop.classList.remove('is-dragging');
      });
    });
    drop.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!f) return;
      // DataTransfer -> input.files : propage le fichier au repli POST natif si besoin.
      try {
        fileInput.files = e.dataTransfer.files;
      } catch (err) {
        showError(root.getAttribute('data-err-drop') || 'Utilise le bouton pour choisir ta photo.');
        return;
      }
      acceptFile(f);
    });
  }

  /* ---------- Pack multi-figurines (état + UI) ----------
     activeExtras / validateExtraPhotos / collectExtras sont partagés avec submitOrder ci-dessous.
     Ils restent neutres si la section n'a pas de bloc bundle. */

  var bundle = root.querySelector('[data-bundle]');
  var activeExtras = [];
  var validateExtraPhotos = function () { return true; };
  var collectExtras = function () { return []; };

  if (bundle) {
    var STR = {
      needPhoto: bundle.getAttribute('data-str-needphoto') || 'Ajoute une photo pour la figurine n°__N__',
      recap: bundle.getAttribute('data-str-recap') || '__N__ figurines',
      savings2: bundle.getAttribute('data-str-savings2') || '-15% appliqué au panier',
      savings3: bundle.getAttribute('data-str-savings3') || '-25% appliqué au panier'
    };

    var recapEl = bundle.querySelector('[data-bundle-recap]');
    var recapCount = bundle.querySelector('[data-bundle-count]');
    var recapSavings = bundle.querySelector('[data-bundle-savings]');

    var hasExtra = function (n) { return activeExtras.indexOf(n) !== -1; };

    var updateRecap = function () {
      var toggle3 = bundle.querySelector('[data-bundle-toggle="3"]');
      if (toggle3) {
        if (hasExtra(2)) toggle3.removeAttribute('data-bundle-locked');
        else toggle3.setAttribute('data-bundle-locked', '');
      }
      var count = 1 + activeExtras.length;
      if (count > 1 && recapEl) {
        recapEl.hidden = false;
        if (recapCount) recapCount.textContent = STR.recap.replace('__N__', count);
        if (recapSavings) recapSavings.textContent = count >= 3 ? STR.savings3 : STR.savings2;
      } else if (recapEl) {
        recapEl.hidden = true;
      }
    };

    var closeExtra = function (n) {
      var extra = bundle.querySelector('[data-extra="' + n + '"]');
      var slot = bundle.querySelector('[data-bundle-add="' + n + '"]');
      if (extra) extra.hidden = true;
      if (slot) slot.classList.remove('is-open');
      var f = bundle.querySelector('[data-extra-photo="' + n + '"]');
      if (f) f.value = '';
      var empty = bundle.querySelector('[data-extra-photo-empty="' + n + '"]');
      var filled = bundle.querySelector('[data-extra-photo-filled="' + n + '"]');
      if (empty) empty.hidden = false;
      if (filled) filled.hidden = true;
      var instr = bundle.querySelector('[data-extra-instr="' + n + '"]');
      if (instr) instr.value = '';
      var idx = activeExtras.indexOf(n);
      if (idx !== -1) activeExtras.splice(idx, 1);
    };

    bundle.querySelectorAll('[data-bundle-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('data-bundle-locked')) return;
        var n = parseInt(btn.getAttribute('data-bundle-toggle'), 10);
        var extra = bundle.querySelector('[data-extra="' + n + '"]');
        var slot = bundle.querySelector('[data-bundle-add="' + n + '"]');
        if (!extra) return;
        extra.hidden = false;
        if (slot) slot.classList.add('is-open');
        if (!hasExtra(n)) activeExtras.push(n);
        updateRecap();
      });
    });

    bundle.querySelectorAll('[data-extra-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-extra-remove'), 10);
        closeExtra(n);
        if (n === 2 && hasExtra(3)) closeExtra(3);
        updateRecap();
      });
    });

    [2, 3].forEach(function (n) {
      var input = bundle.querySelector('[data-extra-photo="' + n + '"]');
      if (!input) return;
      var empty = bundle.querySelector('[data-extra-photo-empty="' + n + '"]');
      var filled = bundle.querySelector('[data-extra-photo-filled="' + n + '"]');
      var preview = bundle.querySelector('[data-extra-photo-preview="' + n + '"]');
      var nameEl = bundle.querySelector('[data-extra-photo-name="' + n + '"]');
      var changeExtra = bundle.querySelector('[data-extra-photo-change="' + n + '"]');

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) { if (empty) empty.hidden = false; if (filled) filled.hidden = true; return; }
        if (file.size > MAX_BYTES || (file.type && ACCEPTED.indexOf(file.type) === -1)) {
          input.value = '';
          if (empty) empty.hidden = false;
          if (filled) filled.hidden = true;
          return;
        }
        if (preview) preview.src = URL.createObjectURL(file);
        if (nameEl) nameEl.textContent = file.name;
        if (empty) empty.hidden = true;
        if (filled) filled.hidden = false;
      });
      if (changeExtra) changeExtra.addEventListener('click', function () { input.click(); });
    });

    var extraVariantId = function (n) {
      var byPos = {};
      bundle.querySelectorAll('[data-extra-option-input="' + n + '"]:checked').forEach(function (i) {
        byPos[i.getAttribute('data-option-position')] = i.value;
      });
      var ordered = Object.keys(byPos).sort(function (a, b) { return a - b; }).map(function (k) { return byPos[k]; });
      if (!ordered.length) return (variants[0] && variants[0].id) || null;
      var v = findVariant(ordered);
      return v ? v.id : null;
    };

    validateExtraPhotos = function () {
      for (var i = 0; i < activeExtras.length; i++) {
        var n = activeExtras[i];
        var ef = bundle.querySelector('[data-extra-photo="' + n + '"]');
        if (!ef || !ef.files || !ef.files.length) {
          var box = bundle.querySelector('[data-extra="' + n + '"]');
          if (box) {
            box.scrollIntoView({ behavior: 'smooth', block: 'center' });
            box.classList.add('is-shake');
            setTimeout(function () { box.classList.remove('is-shake'); }, 500);
          }
          showError(STR.needPhoto.replace('__N__', n));
          return false;
        }
      }
      return true;
    };

    collectExtras = function () {
      var out = [];
      activeExtras.slice().sort().forEach(function (n) {
        var f = bundle.querySelector('[data-extra-photo="' + n + '"]');
        var instrEl = bundle.querySelector('[data-extra-instr="' + n + '"]');
        out.push({
          vid: extraVariantId(n),
          file: f && f.files ? f.files[0] : null,
          instr: instrEl ? instrEl.value : ''
        });
      });
      return out;
    };

    updateRecap();
  }

  /* ---------- Ajout au panier (AJAX → tiroir, repli natif) ---------- */

  var MAX_PHOTO_EDGE = 2048; // on compresse avant l'envoi : upload rapide + ajouts en série fiables

  // Réduit une photo à <= 2048px en JPEG. Fait tomber un 12 Mo à ~0,5 Mo — c'est LA cause n°1
  // de la lenteur et des échecs d'ajout en série (bundle). Sur échec de décodage (HEIC exotique),
  // on renvoie l'original tel quel : rien n'est jamais perdu.
  function downscalePhoto(file) {
    return new Promise(function (resolve) {
      if (!file || !/^image\//.test(file.type || '') || !window.HTMLCanvasElement) { resolve(file); return; }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) { resolve(file); return; }
        var scale = Math.min(1, MAX_PHOTO_EDGE / Math.max(w, h));
        if (scale === 1 && file.size <= 1.5 * 1024 * 1024) { resolve(file); return; } // déjà léger
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(w * scale);
        canvas.height = Math.round(h * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        if (!canvas.toBlob) { resolve(file); return; }
        canvas.toBlob(function (blob) {
          if (!blob || blob.size >= file.size) { resolve(file); return; }
          var name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
          try { resolve(new File([blob], name, { type: 'image/jpeg' })); }
          catch (e) { resolve(blob); }
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  // Ajoute UNE ligne au panier via /cart/add.js (format article unique, photo comprise).
  // C'est la mécanique exacte, éprouvée, de l'ancien thème : un POST multipart par ligne.
  // On enchaîne les lignes du bundle en série SANS délai artificiel, puis on rafraîchit
  // le tiroir une seule fois. Aucune navigation vers /cart : en cas d'échec on reste dans
  // le tiroir avec un message, exactement comme l'ancien thème (jamais de redirection).
  function addOne(ln) {
    var fd = new FormData();
    fd.append('id', String(ln.vid));
    fd.append('quantity', '1');
    if (ln.file) fd.append('properties[Photo]', ln.file, ln.file.name || 'photo.jpg');
    if (ln.instr && ln.instr.trim()) fd.append('properties[Instructions]', ln.instr.trim());
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    });
  }

  // REPLI GARANTI — POST natif classique vers /cart/add (pas .js), en navigation top-level.
  // Pourquoi c'est la bouée de sauvetage : une navigation de page n'est PAS soumise au même
  // filtrage anti-bot que les requêtes fetch (qui se prennent des 429 sur un thème en aperçu
  // non publié). Elle fonctionne donc toujours — le client obtient sa figurine et atterrit sur
  // /cart, où il peut payer. On reconstruit les fichiers (déjà compressés) via DataTransfer.
  // Renvoie false si vraiment impossible (très vieux navigateur sans DataTransfer + bundle).
  function nativeSubmit(lines) {
    if (!window.DataTransfer) {
      if (lines.length === 1 && form) { form.submit(); return true; }
      return false;
    }
    var f = document.createElement('form');
    f.action = routes.cart_add_url;
    f.method = 'post';
    f.enctype = 'multipart/form-data';
    f.setAttribute('accept-charset', 'UTF-8');
    f.style.display = 'none';

    function hidden(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = value;
      f.appendChild(i);
    }
    function fileField(name, file) {
      var i = document.createElement('input');
      i.type = 'file'; i.name = name;
      try { var dt = new DataTransfer(); dt.items.add(file); i.files = dt.files; }
      catch (e) { return; }
      f.appendChild(i);
    }

    var multi = lines.length > 1;
    lines.forEach(function (ln, i) {
      var p = multi ? 'items[' + i + ']' : '';
      var propBase = multi ? p + '[properties]' : 'properties';
      hidden(multi ? p + '[id]' : 'id', ln.vid);
      hidden(multi ? p + '[quantity]' : 'quantity', '1');
      if (ln.instr && ln.instr.trim()) hidden(propBase + '[Instructions]', ln.instr.trim());
      if (ln.file) fileField(propBase + '[Photo]', ln.file);
    });

    document.body.appendChild(f);
    f.submit();
    return true;
  }

  function submitOrder() {
    var strings = (window.theme && window.theme.strings) || {};
    var needsPhoto = root.getAttribute('data-needs-photo') === 'true';
    var mainFile = fileInput && fileInput.files && fileInput.files[0];

    if (needsPhoto && !mainFile) {
      showError(root.getAttribute('data-err-missing') || 'Ajoute ta photo avant de commander.');
      if (fileInput) fileInput.focus();
      if (drop && drop.scrollIntoView) drop.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!validateExtraPhotos()) return;

    clearError();

    var extras = collectExtras();
    var mainInstrEl = root.querySelector('[name="properties[Instructions]"]');
    var lines = [{
      vid: (variantInput && variantInput.value) || (variants[0] && variants[0].id),
      file: mainFile,
      instr: mainInstrEl ? mainInstrEl.value : ''
    }];
    extras.forEach(function (x) { lines.push(x); });

    // Variante introuvable (choix incomplet) : on s'arrête net plutôt que d'envoyer un id vide.
    if (lines.some(function (ln) { return !ln.vid; })) {
      showError(root.getAttribute('data-err-generic') || 'Vérifie tes choix et réessaie.');
      return;
    }

    var restore = atcLabel ? atcLabel.textContent : '';
    if (atc) atc.disabled = true;
    if (atcLabel) atcLabel.textContent = strings.adding || 'Ajout en cours…';

    function restoreBtn() {
      if (atc) atc.disabled = false;
      if (atcLabel) atcLabel.textContent = restore;
    }

    // Réaction immédiate : le tiroir s'ouvre AVEC un spinner pendant l'ajout — plus de bouton figé.
    var addingMsg = lines.length > 1 ? ('Ajout de tes ' + lines.length + ' figurines…') : (strings.adding || 'Ajout au panier…');
    if (window.theme && window.theme.openCartAdding) window.theme.openCartAdding(addingMsg);

    function loadCart() {
      if (window.theme && window.theme.refreshCart) window.theme.refreshCart();
      else if (window.theme && window.theme.openCart) window.theme.openCart();
      else window.location.href = routes.cart_url || '/cart';
    }

    // 1) compresse les photos en parallèle → 2) ajoute chaque ligne en série → 3) tiroir.
    Promise.all(lines.map(function (ln) {
      return downscalePhoto(ln.file).then(function (f) { ln.file = f; });
    }))
      .then(function () {
        return lines.reduce(function (chain, ln) {
          return chain.then(function () { return addOne(ln); });
        }, Promise.resolve());
      })
      .then(function () {
        loadCart();
        restoreBtn();
      })
      .catch(function () {
        // L'ajax a échoué (429 sur thème en aperçu, réseau, format refusé…). On NE laisse
        // JAMAIS le client bloqué : repli natif garanti → sa figurine est ajoutée et il arrive
        // sur /cart, où il peut payer. Si même ça échoue (très vieux navigateur), message.
        if (!nativeSubmit(lines)) {
          showError(root.getAttribute('data-err-generic') || 'Une figurine n’a pas pu être ajoutée. Vérifie tes choix et réessaie.');
          loadCart();
          restoreBtn();
        }
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      // Navigateurs sans fetch/FormData : on laisse le POST natif se faire.
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      submitOrder();
    });
  }
})();
